import * as React from 'react';
import {Link, NavLink} from 'react-router-dom';


import stick_cut from "../../assets/graf/stick_cut.png";
import logo from '../../assets/graf/logo.png';
import logo_long from '../../assets/graf/logo_long.png'
import BasicDropdown from '../dropdown/BasicDropdown';

import {isBrowser, isMobile } from 'react-device-detect';
import { Close, Menu } from '@mui/icons-material';
import MobileNavElement from './MobileNavElement';

export default function Navbar(){

    const [mobileVisible, setMobileVisible] = React.useState(false);

    const elements = [
        {
            text: 'Naslovna',
            link: '/',
            key: 'naslovna'
        },
        {
            text: 'Organizacija konferencije',
            link: '/organizacija',
            key: 'organizacija'
        },
        {
            text: 'Program',
            key: 'program',
        },
        {
            text: 'Oblici sudjelovanja',
            link: '/oblici-sudjelovanja',
            key: 'oblici-sudjelovanja'
        },
        {
            text: "Prijava sudjelovanja",
            link: "/prijava-sudjelovanja",
            key: "prijava-sudjelovanja"
        },
        {
            text: 'Prijava sažetaka',
            link: '/prijava-sazetaka',
            key: 'prijava-sazetaka'
        },

    ]

    if(isMobile){
        elements[2].elements=[

            {
                text: 'Tematska područja',
                link: "/tematska-podrucja",
                key: "tematska-podrucja"
            }
        ]
    } else {
        elements[2].elements=[
                {
                    text: "Pozvani predavači",
                    link: "/pozvani-predavaci",
                    key: "pozvani-predavaci"
                },
                {
                    text: 'Tematska područja',
                    link: "/tematska-podrucja",
                    key: "tematska-podrucja"
                }
            ]
    }

    return (!isMobile?
        <div id="nav" className="nav-white">
            
            <div style={{padding:"50px"}}>
            <div className="flex-row" style={{alignItems:"center", justifyContent:"space-between"}}><Link to="/"><img  src={logo} alt="GKHP32" id="logo"/></Link>
            <div style={{paddingTop: "2vh", paddingBottom:"2vh"}}>
            <div id="nav-list"  className="flex-row">
                
                {elements.map(({text, link, key, elements}, index)=>{
                    return link!=null?
                    <NavLink key={key} to={link}> <div className={ "nav-link pillbox-like " + (index%2==0?"nav-link-even":"nav-link-odd")}>{text}</div></NavLink>
                    :<BasicDropdown key={key}  elements={elements} activeElement={<div className={"nav-link " +(index%2==0?"nav-link-even":"nav-link-odd")}>{text}</div>}/>
                    
                    
                })}
                
            </div>
            
            </div>
            </div>
            </div>
            
        </div>
    :<><div id="nav" className="nav-white">
        <div style={{padding:"50px"}}>
            <div className="flex-row" style={{alignItems:"baseline", justifyContent:"space-between"}}>
                <Link to="/"><img  src={logo} alt="GKHP32 Logo" className="logo-short"/></Link>
                <button onClick={()=>{
                    setMobileVisible(()=>{
                        return mobileVisible?false:true
                    })
                }} id="hanbi">{mobileVisible?<Close style={{height:"2rem", width:"2rem"}}/>:<Menu style={{height:"2rem", width:"2rem"}}/>}</button>
            </div>
        </div>
    </div>
    <div id="mobile-menu" className={mobileVisible?"mobile-menu-visible":""}>
    <MobileNavElement text={<img src={logo_long} alt="GKHP32" className="logo-long"/>}/>
    <div id="mobile-nav-list"  className="flex-column">
                
                {elements.map(({text, link, key, elements}, index)=>{
                  return elements!==undefined? <MobileNavElement text={text} key={index} link={link} elements={elements}/>:<MobileNavElement key={index} text={text} link={link}/>
                    
                })}
                
            </div>
    </div>
    <div style={{textAlign:"center", color:"maroon", fontWeight:"bold", fontSize:"9pt"}}>VAŽNA OBAVIJEST: ROK ZA PRIJAVU SAŽETAKA JE PRODULJEN DO 30.9.2025 !</div>
    </>)
}